<template>
  <div>
    <QS-not-found />
  </div>
</template>

<script>

export default {
  name: 'Page404',
}
</script>

<style lang="scss" scoped>

</style>
